// We check import.meta.env because it's not available for the Chrome Extension

export const IS_PRODUCTION = (import.meta.env && import.meta.env.PROD) ?? true;

export const IS_LOCAL_OR_DEVELOPMENT =
	(typeof process !== 'undefined' &&
		process.env &&
		process.env.NODE_ENV === 'development') ||
	// We can't use import.meta.env.DEV here because the `us-development` deployment is also considered production (NODE_ENV=production)
	(import.meta.env &&
		(import.meta.env.MODE === 'local-development' ||
			import.meta.env.MODE === 'us-development'));

export const IS_STORYBOOK =
	typeof window !== 'undefined' && '__STORYBOOK_PREVIEW__' in window;
